import axios from 'axios';

export  const axiosCircuitExporter = axios.create({
    baseURL:   process.env.REACT_APP_API_CIRCUIT_EXPORTER,
});
